import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface PageContainerProps {
  children: ReactNode;
  className?: string;
  header?: string;
  description?: string;
}

export function PageContainer({ children, className, header, description }: PageContainerProps) {
  return (
    <div className={cn(
      'w-full mx-auto px-3 py-4 md:px-4 md:py-5',
      'max-w-5xl',
      className
    )}>
      {(header || description) && (
        <div className="text-center sm:text-left mb-4 md:mb-6">
          {header && <h1 className="text-2xl md:text-3xl font-bold mb-1">{header}</h1>}
          {description && <p className="text-sm text-muted-foreground">{description}</p>}
        </div>
      )}
      {children}
    </div>
  );
}
